import { Box, Typography, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { TableRestaurant, ReceiptLong, EventAvailable, WarningAmber } from '@mui/icons-material';
import useDashboardStats from '../hooks/useDashboardStats';
import { useTranslation } from 'react-i18next';
import AzioniRapide from './AzioniRapide';
import { getTenantTranslation } from '../utils/getTenantTranslation';

const DashboardCards = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const tenantType = localStorage.getItem('tenantType');
  const isConferenceTenant = String(tenantType || '').toUpperCase() === 'SALE_CONGRESSI';

  const { stats, loading, error } = useDashboardStats();

  if (loading) return <Typography>{t('loading')}</Typography>;
  if (error) return <Typography color="error">{t('reservations_details.error')}: {error}</Typography>;
  if (!stats) return null;

  const baseCards = [
    {
      title: getTenantTranslation(t, tenantType, 'occupiedTables'),
      value: `${stats.tables.occupied}/${stats.tables.total}`,
      color: theme.palette.mode === "light" ? "#FFDEDE" : '#584747',
      colorBorderText:  theme.palette.mode === "light" ? "#E00C0C" : "#FF8C8C",
      boxShadow: "0 6px 24.5px 0 rgba(224, 12, 12, 0.25)",
      icon: <TableRestaurant sx={{ fontSize: 32, color: theme.palette.mode === "light" ? "#E00C0C" : "#FF8C8C", }} />,
    },
  ];

  const restaurantCards = [
    ...baseCards,
    {
      title: t("activeOrders"),
      value: stats.activeOrders.toString().padStart(2, '0'),
      color: theme.palette.mode === "light" ? "#D8FFE5" : '#3F4942',
      colorBorderText:  theme.palette.mode === "light" ? "#125605" : "#78BD6A",
      boxShadow: "0 6px 24.5px 0 rgba(24, 148, 0, 0.25)",
      icon: <ReceiptLong sx={{ fontSize: 32, color: theme.palette.mode === "light" ? "#125605" : "#78BD6A", }} />,
    },
    // {
    //   title: t("avgTime"),
    //   value: `${stats.averageTimeMinutes} min.`,
    //   color: theme.palette.mode === "light" ? "#FFF0CF" : '#5B5343',
    //   colorBorderText:  theme.palette.mode === "light" ? "#CC4B00" : "#F9934B",
    //   boxShadow: "0 6px 24.5px 0 rgba(204, 75, 0, 0.25)",
    //   icon: <Timer sx={{ fontSize: 32, color: theme.palette.mode === "light" ? "#CC4B00" : "#F9934B", }} />,
    // },
    // {
    //   title: t("revenueToday"),
    //   value: `+ ${stats.revenueToday.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' })}`,
    //   color: theme.palette.mode === "light" ? "#E9F3FF" : '#192F49',
    //   colorBorderText:  theme.palette.mode === "light" ? "#004394" : "#549AEF",
    //   boxShadow: "0 6px 24.5px 0 rgba(0, 67, 148, 0.25)",
    //   icon: <Euro sx={{ fontSize: 32, color: theme.palette.mode === "light" ? "#004394" : "#549AEF", }} />,
    // },
  ];

  const conferenceCards = [
    ...baseCards,
    {
      title: t("prenotazioniConfermate"),
      value: Number(stats.confirmedReservations || 0).toString().padStart(2, '0'),
      color: theme.palette.mode === "light" ? "#D8FFE5" : '#3F4942',
      colorBorderText:  theme.palette.mode === "light" ? "#125605" : "#78BD6A",
      boxShadow: "0 6px 24.5px 0 rgba(24, 148, 0, 0.25)",
      icon: <EventAvailable sx={{ fontSize: 32, color: theme.palette.mode === "light" ? "#125605" : "#78BD6A", }} />,
    },
    {
      title: t("preventiviScaduti"),
      value: Number(stats.expiredQuotes || 0).toString().padStart(2, '0'),
      color: theme.palette.mode === "light" ? "#FFF4C2" : '#5B5343',
      colorBorderText:  theme.palette.mode === "light" ? "#B77900" : "#FFD166",
      boxShadow: "0 6px 24.5px 0 rgba(183, 121, 0, 0.25)",
      icon: <WarningAmber sx={{ fontSize: 32, color: theme.palette.mode === "light" ? "#B77900" : "#FFD166", }} />,
    },
  ];

  const cards = isConferenceTenant ? conferenceCards : restaurantCards;

  return (
    <Box sx={{ px: 4, my: 3 }}>
      <Grid container spacing={3}>
        {cards.map((card, idx) => (
          <Grid item xs={12} sm={6} md={isConferenceTenant ? 3 : 3} key={idx}>
            <Box
              sx={{
                backgroundColor: card.color,
                border: "1px solid",
                borderColor: card.colorBorderText,
                color:card.colorBorderText,
                borderRadius: 2,
                boxShadow: card.boxShadow,
                padding: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                height: '100%',
              }}>
              <Box>
                <Typography variant="body2">{card.title}</Typography>
                <Typography variant="h6" fontWeight="bold">{card.value}</Typography>
              </Box>
              {card.icon}
            </Box>
          </Grid>
        ))}
        <Grid item xs={12} sm={12} md={isConferenceTenant ? 3 : 6} key={"quickActions"}>
            <AzioniRapide/>
          </Grid>
      </Grid>
    </Box>
  );
};

export default DashboardCards;
